import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import DownPaymentCalculator from "./DownPaymentCalculator.esm.js";
import { FieldConfig } from "./DownPaymentCalculator.utils.esm.js";
const DownPaymentCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      homePrice,
      percentage
    } = attrs;
    const defaultValues = {
      homePrice,
      percentage
    };
    return /* @__PURE__ */ jsx(DownPaymentCalculator, { ...{
      defaultValues
    } }, isEditor() ? JSON.stringify(defaultValues) : void 0);
  },
  metadata: {
    version: "1.0",
    name: "constellation/downpayment-calculator",
    title: "Down Payment Calculator",
    description: "Estimate how much to save for a down payment.",
    icon: "chart-line",
    keywords: ["mortgages", "calculators", "down", "payment"],
    category: "Calculators",
    supports: {
      customClassName: false,
      html: false
    },
    attributes: {
      [FieldConfig.homePrice.name]: {
        type: "number",
        label: "Default home price",
        default: 65e4,
        control: "number"
      },
      [FieldConfig.percentage.name]: {
        type: "number",
        label: "Default down payment %",
        default: 10,
        control: "number"
      }
    }
  }
};
export {
  DownPaymentCalculatorBlock as default
};
